import * as React from 'react';
import * as styles from './LightTableView.css';
import { GiftsContainer } from './components/Gifts';
import { ServicesContainer } from './components/Services';
import { TableHeaderContainer } from './components/TableHeader';

export const LightTableView = () => {
  return (
    <div className={styles['table']}>
      <TableHeaderContainer />

      <ServicesContainer />

      <GiftsContainer />
    </div>
  );
};
